import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export interface Notification {
  user: { name: string };
  salutation: string;
  body: string;
  time: Date;
  closed: boolean;
}

export interface NotificationState {
  message: null | Notification[];
}

const state = {
  message: null
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
